(function() {
	// globals
	PM.Shell = {};

	// Holds the current authenticated user, or null if not logged in
	PM.Shell.currentUser = null;

	// app functions

	var MAIN_DOMAIN_PATHS = ['/tos', '/terms', '/privacy', '/docs/*'];

	PM.Shell.isPublicPath = function(pathname) {
		return MAIN_DOMAIN_PATHS.some(function(p) {
			if (p.endsWith('/*')) {
				var base = p.slice(0, -2);
				return pathname === base || pathname.indexOf(base + '/') === 0;
			}
			return pathname === p;
		});
	};

	/**
	 * Fetch the current auth state from /api/auth/me and store it in PM.Shell.currentUser.
	 * @returns {Promise} Resolves with the auth response { authenticated, user }.
	 */
	PM.Shell.fetchUser = function() {
		return $.get('/api/auth/me').then(function(data) {
			PM.Shell.currentUser = data;
			return data;
		});
	};

	/**
	 * Check if the user is in the wrong domain and should be redirected.
	 * @returns {boolean} true if a redirect was triggered, false otherwise.
	 */
	PM.Shell.checkRedirect = function() {
		var data = PM.Shell.currentUser;
		if (!data || !data.mainUrl) return false;

		var mainOrigin = new URL(data.mainUrl).origin;
		var isMainDomain = window.location.origin === mainOrigin;
		var isPublicPath = PM.Shell.isPublicPath(window.location.pathname);

		if (data.authenticated && isMainDomain && !isPublicPath) {
			window.location.href = data.organization.url + window.location.pathname + window.location.search;
			return true;
		}
		if (!data.authenticated && !isMainDomain) {
			window.location.href = data.mainUrl + '/api/auth/login';
			return true;
		}
		return false;
	};

	/**
	 * Render the main shell (navbar, language switcher, page container).
	 * Fetches the current user first so the template can conditionally show
	 * nav items and the user menu.
	 * @returns {Promise} Resolved when the shell DOM is rendered.
	 */
	PM.Shell.renderShell = function() {
		document.title = 'PManager';

		return $.when(
			PM.Shell.fetchUser(),
			ejs.preloadTemplate('/app/shell/templates/main.ejs'),
			ejs.preloadTemplate('/app/shell/templates/not-found.ejs'),
			ejs.preloadTemplate('/app/shell/templates/org-items.ejs')
		).then(function() {
			if (PM.Shell.checkRedirect()) {
				return new Promise(function() {});
			}
			var mainOrigin = PM.Shell.currentUser.mainUrl ? new URL(PM.Shell.currentUser.mainUrl).origin : '';
			var isMainDomain = window.location.origin === mainOrigin;
			var isPublicPath = PM.Shell.isPublicPath(window.location.pathname);

			// Public paths belong on main domain only. Unauthenticated users on subdomain
			// are redirected by checkRedirect, so only authenticated users reach here.
			if (!isMainDomain && isPublicPath) {
				return $.get('/api/auth/orgs').then(function(data) {
					$('body').addClass('js-app-locked');
					PM.Shell.currentUser.otherOrganizations = data.organizations;
					$('.js-main-content').html(ejs.rr('/app/shell/templates/main.ejs', PM.Shell.currentUser));
					PM.Shell.applyPermissionCSS();
					PM.Shell.initSidebar();
					$('.js-page-container').html(ejs.rr('/app/shell/templates/not-found.ejs', {}));
				});
			}

			if (!PM.Shell.currentUser.authenticated || (isMainDomain && isPublicPath)) {
				$('body').removeClass('js-app-locked');
				var shellData = Object.assign({}, PM.Shell.currentUser, { authenticated: false });
				$('.js-main-content').html(ejs.rr('/app/shell/templates/main.ejs', shellData));
				PM.Shell.applyPermissionCSS();
				return;
			}
			return $.get('/api/auth/orgs').then(function(data) {
				$('body').addClass('js-app-locked');
				PM.Shell.currentUser.otherOrganizations = data.organizations;
				$('.js-main-content').html(ejs.rr('/app/shell/templates/main.ejs', PM.Shell.currentUser));
				PM.Shell.applyPermissionCSS();
				PM.Shell.initSidebar();
				PM.Shell.updateLastUpdated();
			});
		});
	};

	/**
	 * Initialize sidebar toggle functionality.
	 */
	PM.Shell.initSidebar = function() {
		var $sidebar = $('#app-sidebar');
		var $overlay = $('#app-sidebar-overlay');
		var $main = $('#app-main');
		var $toggle = $('#app-sidebar-toggle');

		if (!$sidebar.length) return;

		function closeOverlay() {
			$sidebar.removeClass('js-sidebar-visible');
			$overlay.removeClass('js-visible');
		}

		function isSmallScreen() {
			return window.matchMedia('(max-width: 991.98px)').matches;
		}

		$toggle.on('click', function() {
			if ($sidebar.hasClass('js-sidebar-visible')) {
				closeOverlay();
			} else if (isSmallScreen()) {
				$sidebar.addClass('js-sidebar-visible');
				$overlay.addClass('js-visible');
			} else {
				$sidebar.toggleClass('js-sidebar-collapsed');
				$main.toggleClass('js-sidebar-collapsed');
			}
		});

		$overlay.on('click', closeOverlay);

		$(document).on('keydown', function(e) {
			if (e.key === 'Escape') closeOverlay();
		});

		// Sidebar collapsible group toggles
		$('.js-sidebar-group-toggle').on('click', function(e) {
			e.preventDefault();
			var $submenu = $(this).next('.js-sidebar-submenu');
			var isCollapsed = $submenu.hasClass('js-collapsed');

			if (isCollapsed) {
				$submenu.removeClass('js-collapsed').css('max-height', '');
				$submenu.css('max-height', $submenu[0].scrollHeight + 'px');
				$(this).removeClass('js-collapsed');
			} else {
				$submenu.css('max-height', $submenu[0].scrollHeight + 'px');
				void $submenu[0].offsetHeight;
				$submenu.css('max-height', '0');
				$submenu.addClass('js-collapsed');
				$(this).addClass('js-collapsed');
			}
		});

		// Set initial submenu heights for transition support
		$('.js-sidebar-submenu').each(function() {
			if (!$(this).hasClass('js-collapsed')) {
				$(this).css('max-height', this.scrollHeight + 'px');
			}
		});
	};

	/**
	 * Programmatically open a sidebar submenu group.
	 * @param {string} group - The data-sidebar-link value of the group toggle parent
	 */
	function openSidebarSubmenu(group) {
		var $toggle = $('.js-sidebar-group-toggle[data-sidebar-link="' + group + '"]');
		var $submenu = $toggle.next('.js-sidebar-submenu');
		if ($submenu.hasClass('js-collapsed')) {
			$submenu.removeClass('js-collapsed').css('max-height', '');
			var h = $submenu[0].scrollHeight;
			$submenu.css('max-height', h + 'px');
			$toggle.removeClass('js-collapsed');
		}
	}

	window.openSidebarSubmenu = openSidebarSubmenu;

	/**
	 * Update the sidebar active link based on the current page.
	 * @param {string} page - The page key (dashboard, plan, people, projects, config)
	 */
	PM.Shell.setSidebarActive = function(page) {
		$('.app-sidebar-link, .app-sidebar-sublink').removeClass('active');
		$('.app-sidebar-link[data-sidebar-link="' + page + '"]').addClass('active');
		$('.app-sidebar-sublink[data-sidebar-link="' + page + '"]').addClass('active');

		if (page && page.startsWith('config-integrations')) {
			$('.js-sidebar-group-toggle[data-sidebar-link="config-integrations"]').addClass('active');
			openSidebarSubmenu('config-integrations');
		}
	};

	/**
	 * Update breadcrumb in the top bar.
	 * @param {Array} crumbs - Array of { label: string, href?: string } objects
	 */
	PM.Shell.setBreadcrumb = function(crumbs) {
		var $bc = $('.js-breadcrumb');
		if (!$bc.length) return;
		var html = '';
		for (var i = 0; i < crumbs.length; i++) {
			if (i > 0) {
				html += '<span class="app-breadcrumb-separator">&rsaquo;</span>';
			}
			if (i === crumbs.length - 1 || !crumbs[i].href) {
				html += '<span class="app-breadcrumb-current">' + crumbs[i].label + '</span>';
			} else {
				html += '<a href="' + crumbs[i].href + '">' + crumbs[i].label + '</a>';
			}
		}
		$bc.html(html);
	};

	/**
	 * Update the "last updated" timestamp in the sidebar and footer.
	 */
	PM.Shell.updateLastUpdated = function() {
		var now = new Date();
		var formatted = now.toLocaleDateString(i18next.language, {
			year: 'numeric',
			month: 'short',
			day: 'numeric',
			hour: '2-digit',
			minute: '2-digit'
		});
		var text = i18next.t('Last updated') + ': ' + formatted;
		$('.js-last-updated').text(text);
		$('.js-last-updated-footer').text(text);
	};

	PM.Shell.renderHomePage = function() {
		return PM.Shell.fetchUser().then(function(authData) {
			if (PM.Shell.currentUser.authenticated) {
				page('/dashboard');
				return;
			}
			var flags = PM.Shell.currentUser.flags || {};
			if (!flags.pricing) {
				$('.js-page-container').html(ejs.rr('/app/shell/templates/home.ejs', {
					authenticated: authData.authenticated,
					user: authData.user || {},
					pricingEnabled: false
				}));
				return;
			}
			ejs.preloadTemplate('/app/pricing/templates/plans.ejs').then(function() {
				$.get('/api/billing/plans').then(function(plans) {
					$('.js-page-container').html(ejs.rr('/app/shell/templates/home.ejs', {
						authenticated: authData.authenticated,
						user: authData.user || {},
						plans: plans,
						featureLabels: PM.Pricing.getFeatureLabels(),
						currentTier: undefined,
						pricingEnabled: true
					}));
				});
			});
		});
	};

	PM.Shell.renderPrivacyPage = function() {
		PM.Shell.setSidebarActive('');
		PM.Shell.setBreadcrumb([{ label: i18next.t('Privacy') }]);
		var lang = i18next.language || 'en';
		var lng = ['en', 'de', 'it'].indexOf(lang) !== -1 ? lang : 'en';
		return $('.js-page-container').html(ejs.rr('/app/shell/templates/privacy-' + lng + '.ejs'));
	};

	PM.Shell.renderTosPage = function() {
		PM.Shell.setSidebarActive('');
		PM.Shell.setBreadcrumb([{ label: i18next.t('Terms of Use') }]);
		var lang = i18next.language || 'en';
		var lng = ['en', 'de', 'it'].indexOf(lang) !== -1 ? lang : 'en';
		return $('.js-page-container').html(ejs.rr('/app/shell/templates/tos-' + lng + '.ejs'));
	};

	PM.Shell.renderNotFound = function() {
		$('.js-page-container').html(ejs.rr('/app/shell/templates/not-found.ejs', {}));
	};

	/**
	 * Generate and inject a <style> tag that hides elements whose
	 * [data-permission] value is not present in the user's granted permissions.
	 * Elements for permissions the user does not have get display:none.
	 * If the user has no permissions at all (unauthenticated or no role),
	 * all permission-gated elements are hidden.
	 */
	PM.Shell.applyPermissionCSS = function() {
		$('style#perm-styles').remove();

		var missing = PM.Shell.currentUser.allPermissions;
		if (PM.Shell.currentUser.permissions) {
			missing = PM.Shell.currentUser.allPermissions.filter(function(p) {
				return PM.Shell.currentUser.permissions.indexOf(p) === -1;
			});
		}

		if (missing.length === 0) return;

		var css = missing.map(function(p) {
			return '[data-permission="' + p + '"] { display: none !important; }';
		}).join('\n');

		$('<style id="perm-styles">').text(css).appendTo('head');
	};

	/**
	 * Check if the current user has the given permission.
	 * @param {string} permission - The permission name to check (e.g. 'view_plan')
	 * @returns {boolean}
	 */
	PM.Shell.checkPermission = function(permission) {
		var perms = PM.Shell.currentUser && PM.Shell.currentUser.permissions;
		if (!perms) return false;
		return perms.indexOf(permission) !== -1;
	};

	/**
	 * Render a permission-denied message into the page container.
	 */
	PM.Shell.renderPermissionDenied = function() {
		var user = PM.Shell.currentUser;
		$('.js-page-container').html(ejs.rr('/app/shell/templates/permission-denied.ejs', {
			currentUser: user
		}));
		PM.Shell.setSidebarActive('');
		PM.Shell.setBreadcrumb([]);
	};

	/**
	 * Create a page.js route handler that checks a permission before rendering.
	 * Use to wrap existing route handlers:
	 *
	 *   page('/plan', PM.Shell.routeWithPermission('view_plan', PM.Plan.renderPlanPage));
	 *
	 * @param {string} permission - Permission required to access the route
	 * @param {Function} renderFn  - The original render function
	 * @returns {Function}         - A page.js-compatible handler
	 */
	PM.Shell.routeWithPermission = function(permission, renderFn) {
		return function(ctx) {
			if (PM.Shell.checkPermission(permission)) {
				renderFn(ctx);
			} else {
				PM.Shell.renderPermissionDenied();
			}
		};
	};

	/**
	 * Check if the current user's plan includes the given features.
	 * Mirrors the backend requireFeature middleware.
	 * Example: PM.Shell.checkFeature('jira', 'archives')
	 * @returns {boolean}
	 */
	PM.Shell.checkFeature = function() {
		if (PM.Shell.currentUser && PM.Shell.currentUser.flags && PM.Shell.currentUser.flags.pricing === false) {
			return true;
		}
		var features = Array.prototype.slice.call(arguments);
		var current = PM.Shell.currentUser && PM.Shell.currentUser.features;
		if (!current || !Array.isArray(current)) return false;
		return features.some(function(f) { return current.indexOf(f) !== -1; });
	};

	// events

	// Global Error Handling Setup
	window.onerror = function(message, source, lineno, colno, error) {
		console.error(`An unhandled exception occurred in ${source}:${lineno}. Details: ${message}`);
		new Notify({
			status: 'error',
			text: 'Sorry something went wrong 😢',
			timeout: 5000
		});
		return true; // Prevent default browser error handling
	};

	$(document).ajaxError(function(event, xhr, settings) {
		if (xhr.handled) return;

		if (xhr.status === 402) {
			var msg = xhr.responseJSON && xhr.responseJSON.error || i18next.t('Plan upgrade required');
			new Notify({
				status: 'warning',
				text: msg + ' <a href="/pricing" style="color:inherit;text-decoration:underline;">' + i18next.t('Upgrade') + '</a>',
				timeout: 8000
			});
			return;
		}

		let errorMessage = 'AJAX request failed.';
		if (xhr.statusText) {
			errorMessage += ` Status: ${xhr.status} (${xhr.statusText})`;
		}
		console.error('AJAX Error:', errorMessage);

		let notifyText = 'Sorry something went wrong 😢';
		try {
			var json = JSON.parse(xhr.responseText);
			if (json && json.error) {
				notifyText = json.error;
			}
		} catch (e) {}

		new Notify({
			status: 'error',
			text: notifyText,
			timeout: 5000
		});
	});

	$(document).on('click', '.js-try-demo', function(e) {
		e.preventDefault();
		var $btn = $(this).prop('disabled', true);
		var originalHtml = $btn.html();
		$btn.html('<span class="spinner-border spinner-border-sm" role="status"></span> ' + i18next.t('Starting demo...'));
		$.post('/api/demo/start', function(data) {
			window.location.href = data.redirectUrl;
		}).fail(function() {
			$btn.prop('disabled', false).html(originalHtml);
		});
	});

	$(document).on('click', '.js-set-default-org', function(e) {
		e.preventDefault();
		e.stopPropagation();
		var $star = $(this).prop('disabled', true);
		var orgId = $star.data('org-id');

		$.ajax({
			url: '/api/auth/orgs/default',
			method: 'PUT',
			contentType: 'application/json',
			data: JSON.stringify({ organizationId: orgId })
		}).done(function(data) {
			PM.Shell.currentUser.otherOrganizations = data.organizations;
			var newHtml = ejs.rr('/app/shell/templates/org-items.ejs', { organizations: data.organizations });
			var $menu = $('.js-user-menu .dropdown-menu');
			$menu.find('.js-org-item').remove();
			var $logoutSep = $menu.children('li').has('.js-user-logout').prev('li');
			if ($logoutSep.length) {
				$(newHtml).insertBefore($logoutSep);
			} else {
				$menu.append(newHtml);
			}
			new Notify({ status: 'success', text: i18next.t('Default organization updated.'), timeout: 3000 });
		});
	});

	// app startup
	page('*', function(ctx, next) {
		if (PM.Shell.checkRedirect()) return;
		var data = PM.Shell.currentUser;
		if (data && data.mainUrl) {
			var mainOrigin = new URL(data.mainUrl).origin;
			var isMainDomain = window.location.origin === mainOrigin;
			var isPublicPath = PM.Shell.isPublicPath(ctx.pathname);
			if (!isMainDomain && isPublicPath) {
				PM.Shell.renderNotFound();
				return;
			}
		}
		next();
	});
	page('/', PM.Shell.renderHomePage);
	page('/privacy', PM.Shell.renderPrivacyPage);
	page('/tos', PM.Shell.renderTosPage);
})();
